
import IntakeFormComponent from './intake-form.component';
import IntakeFormSubmitResultComponent from './intake-form-submit-result.component';
import { intakeReducer } from './intake.reducer';
import * as intakeActions from './intake.actions';

export {
  IntakeFormComponent,
  IntakeFormSubmitResultComponent,
  intakeReducer,
  intakeActions,
}



// WEBPACK FOOTER //
// src/intake/index.js